import { TAB_OPTIONS } from "../../../app/constants/config/systemTasks";
import { tasksConfig } from "./viewTasks";

const { OPENED_TASKS, COMPLETED_TASKS, BACKED_UP_TASKS } = TAB_OPTIONS;
const { SUB_TABS } = OPENED_TASKS;

export const tabItems = [
  {
    id: OPENED_TASKS.ID,
    label: OPENED_TASKS.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.OPENED.ID,
    label: SUB_TABS.OPENED.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.ONGOING.ID,
    label: SUB_TABS.ONGOING.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.PDG_ADMIN_RV.ID,
    label: SUB_TABS.PDG_ADMIN_RV.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.PDG_FINANCE_RV.ID,
    label: SUB_TABS.PDG_FINANCE_RV.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.PDG_CLIENT_FB.ID,
    label: SUB_TABS.PDG_CLIENT_FB.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: SUB_TABS.PDG_MGR_RV.ID,
    label: SUB_TABS.PDG_MGR_RV.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: COMPLETED_TASKS.ID,
    label: COMPLETED_TASKS.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
  {
    id: BACKED_UP_TASKS.ID,
    label: BACKED_UP_TASKS.TAB_LABEL,
    isLoading: true,
    count: 0,
  },
];

export const mainTabItems = [
  { id: OPENED_TASKS.ID, label: OPENED_TASKS.TAB_LABEL },
  { id: COMPLETED_TASKS.ID, label: COMPLETED_TASKS.TAB_LABEL },
  { id: BACKED_UP_TASKS.ID, label: BACKED_UP_TASKS.TAB_LABEL },
];

export const openedSubTabItems = [
  { id: SUB_TABS.OPENED.ID, label: SUB_TABS.OPENED.TAB_LABEL },
  { id: SUB_TABS.ONGOING.ID, label: SUB_TABS.ONGOING.TAB_LABEL },
  { id: SUB_TABS.PDG_ADMIN_RV.ID, label: SUB_TABS.PDG_ADMIN_RV.TAB_LABEL },
  { id: SUB_TABS.PDG_FINANCE_RV.ID, label: SUB_TABS.PDG_FINANCE_RV.TAB_LABEL },
  { id: SUB_TABS.PDG_CLIENT_FB.ID, label: SUB_TABS.PDG_CLIENT_FB.TAB_LABEL },
  { id: SUB_TABS.PDG_MGR_RV.ID, label: SUB_TABS.PDG_MGR_RV.TAB_LABEL },
];

export const slicesConfigReferenceMap = {
  [OPENED_TASKS.ID]: {
    id: OPENED_TASKS.ID,
    taskStatusArray: OPENED_TASKS.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(OPENED_TASKS.ID, OPENED_TASKS.TABLE_LABEL),
  },
  [SUB_TABS.OPENED.ID]: {
    id: SUB_TABS.OPENED.ID,
    taskStatusArray: SUB_TABS.OPENED.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.OPENED.ID, SUB_TABS.OPENED.TAB_LABEL),
  },
  [SUB_TABS.ONGOING.ID]: {
    id: SUB_TABS.ONGOING.ID,
    taskStatusArray: SUB_TABS.ONGOING.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.ONGOING.ID, SUB_TABS.ONGOING.TAB_LABEL),
  },
  [SUB_TABS.PDG_ADMIN_RV.ID]: {
    id: SUB_TABS.PDG_ADMIN_RV.ID,
    taskStatusArray: SUB_TABS.PDG_ADMIN_RV.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.PDG_ADMIN_RV.ID, SUB_TABS.PDG_ADMIN_RV.TAB_LABEL),
  },
  [SUB_TABS.PDG_FINANCE_RV.ID]: {
    id: SUB_TABS.PDG_FINANCE_RV.ID,
    taskStatusArray: SUB_TABS.PDG_FINANCE_RV.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.PDG_FINANCE_RV.ID, SUB_TABS.PDG_FINANCE_RV.TAB_LABEL),
  },
  [SUB_TABS.PDG_CLIENT_FB.ID]: {
    id: SUB_TABS.PDG_CLIENT_FB.ID,
    taskStatusArray: SUB_TABS.PDG_CLIENT_FB.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.PDG_CLIENT_FB.ID, SUB_TABS.PDG_CLIENT_FB.TAB_LABEL),
  },
  [SUB_TABS.PDG_MGR_RV.ID]: {
    id: SUB_TABS.PDG_MGR_RV.ID,
    taskStatusArray: SUB_TABS.PDG_MGR_RV.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(SUB_TABS.PDG_MGR_RV.ID, SUB_TABS.PDG_MGR_RV.TAB_LABEL),
  },
  [COMPLETED_TASKS.ID]: {
    id: COMPLETED_TASKS.ID,
    taskStatusArray: COMPLETED_TASKS.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(COMPLETED_TASKS.ID, COMPLETED_TASKS.TABLE_LABEL),
  },
  [BACKED_UP_TASKS.ID]: {
    id: BACKED_UP_TASKS.ID,
    taskStatusArray: BACKED_UP_TASKS.FETCH_BY_STATUS_ARRAY,
    getConfig: () => tasksConfig(BACKED_UP_TASKS.ID, BACKED_UP_TASKS.TABLE_LABEL),
    isBackedUp: true,
  },
};
